enum DepositEntryPoints {
  getInventoryInfo = '/api/inventory-management/inventory/deposit/{deposit}/inventory/info',
  inventoryUpdate = '/api/inventory-management/inventory/deposit/{deposit}/inventory/{id}',
  inventoryValidate = '/api/inventory-management/inventory/deposit/{deposit}/inventory/validated',
  getMarks = '/api/inventory-management/inventory/deposit/{deposit}/marks',
  getSelect = '/api/select/deposit',
}

export default DepositEntryPoints;
